export const getCostSummaryHeaderData = (state) => state.costSummary.headerData;
export const getCostSummaryCostData = (state) => state.costSummary.costData;
export const getCostSummaryTableData = (state) => state.costSummary.tableData;
export const getCostSummaryFetchStatus = (state) => state.costSummary.fetchStatus;
export const getCostSummaryFetchStatusText = (state) => state.costSummary.fetchStatusText;
